import { render, staticRenderFns } from "./SessionDetailRoute.vue?vue&type=template&id=00b6aa35&"
import script from "./SessionDetailRoute.vue?vue&type=script&lang=ts&"
export * from "./SessionDetailRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports